import React, {useState} from 'react';
import '../css/index.css';
import Transparent_logo from '../assests/Transparent_Logo.png';
import { NavLink, Link} from 'react-router-dom';

export default function Navigation() {

    const [isActive, setActive] = useState(false);

    return (
        <div className='container'>
        <nav className="nav-desktop">
            <div className="top-row">
                <Link className="logo" to="/">

                    <img src={Transparent_logo} alt="mtechno.in logo" />
                    <span>mtechno.in</span>

                </Link>
                <div className="link-list">
                    <ul>
                       
                        <li><NavLink  to="/" className={({isActive})=>(isActive?'active':'')}>HOME</NavLink></li>
                        <li><NavLink to="/bio" className={({isActive})=>(isActive?'active':'')}>BIO</NavLink></li>
                        <li><NavLink to="/blogs" className={({isActive})=>(isActive?'active':'')}>BLOGS</NavLink></li>
                         <li><NavLink to="/previousworks" className={({isActive})=>(isActive?'active':'')}>WORKS</NavLink></li>
                        <li><NavLink to="/contact" className={({isActive})=>(isActive?'active':'')}>CONTACT</NavLink></li>
                    </ul>
                </div>
            </div>

        </nav>

       
        <nav className={isActive?'nav-mobile in-front':'nav-mobile'}>
            <div className="top-row-mobile">
                <NavLink to="/">
                    <div className="ballon">Home</div>
                </NavLink>
                <NavLink to="/blogs">
                    <div className="ballon">Blogs</div>
                </NavLink>
                <NavLink to="/bio">
                    <div className="ballon">Bio</div>
                </NavLink>
                 <NavLink to="/previousworks">
                    <div className="ballon">Works</div>
                </NavLink>
                <NavLink to="/contact">
                    <div className="ballon">Contact</div>
                </NavLink>
            </div>
             <div onClick={()=>setActive(!isActive)}>
                <div className="mobile-logo-container">
                    <img src={Transparent_logo} alt="mtechno.in logo"/>
                    <span>mtechno.in</span>
                    <span className="blinker pulse">CLICK HERE</span>
                </div>
            </div>
        </nav>
        </div>
    );
}